import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "app-name" }
const _hoisted_3 = { class: "layout-menu-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppSubmenu = _resolveComponent("AppSubmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: "layout-sidebar",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMenuClick && _ctx.onMenuClick(...args))),
    style: {"min-width":"105px"}
  }, [
    _createVNode(_component_router_link, {
      to: `/${_ctx.$route.path.split('/')[1]}`,
      class: "logo"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          style: {"max-width":"100%","height":"55px"},
          src: _ctx.activityLogo,
          alt: _ctx.$t('workspaceLayout.dashboard')
        }, null, 8, _hoisted_1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.appName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppSubmenu, {
        items: _ctx.model,
        layoutMode: _ctx.layoutMode,
        parentMenuItemActive: true,
        menuActive: _ctx.active,
        mobileMenuActive: _ctx.mobileMenuActive,
        root: true,
        onMenuitemClick: _ctx.onMenuItemClick,
        onRootMenuitemClick: _ctx.onRootMenuItemClick
      }, null, 8, ["items", "layoutMode", "menuActive", "mobileMenuActive", "onMenuitemClick", "onRootMenuitemClick"])
    ])
  ]))
}